import React from "react";
import Layout from "../components/Layout";
import { DocumentoSolicitud } from "../components";
const AgenteDocumental = () => {
  return (
    <>
      <Layout />
      <div>
        <DocumentoSolicitud />
      </div>
    </>
  );
};

export default AgenteDocumental;
